import React, { useContext } from 'react';
import { PermisionDenied } from 'views/pages/manage/common/commonComponents';
import { useGetPermissions } from 'layouts/customHook';
import PaymodeAccountConfig from './PaymodeAccountConfig';



const PaymodeAccountSetup = () => {
    const userPermissions = useGetPermissions("sapAccountMaster");
    return userPermissions ? <PaymodeAccountConfig userPermissions={userPermissions} /> : <PermisionDenied />
}

export default PaymodeAccountSetup;